<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <!-- 中间 -->
        <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">SPECIALTY</div>
          </div>
          <div class="chinese">特产</div>
        </div>
        <!-- 底部 -->
        <div class="footerMenu" style="margin-left:1.71875vw">
          <div :class="classNameD" @mouseover="classNameD = 'colAHover'" @mouseout="classNameD = 'colA'" @click="openTypeLise(1)">
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">地</div>
            <div class="chaFont">道</div>
            <div class="chaFont">特</div>
            <div class="chaFont">产</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div :class="classNameA" @mouseover="classNameA = 'colAHover'" @mouseout="classNameA = 'colA'" @click="openTypeLise(2)">
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">商</div>
            <div class="chaFont">家</div>
            <div class="chaFont">推</div>
            <div class="chaFont">荐</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/css/switch.css"
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      this.$store.commit("setChildMenu", 7);
      this.$store.commit("setTabPage", type);
      this.$store.commit("setShowSwitchMenu", false);
      let name = "SpecialtyList";
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/specialty/specialtySwitch.vue